module.exports = __webpack_public_path__ + "media/Rafael-Krux-Alien-Invasion.f90a013e.mp3";